import React from "react";
import NavBar from "../components/NavBar";
import Articles from "../components/Articles";
import Footer from "../components/Footer";

const KnowledgeCenter = () => {
    return(
        <div>
            <NavBar/>
            <Articles/>
            <Footer/>
        </div>
    )
}

export default KnowledgeCenter;